import global from "@/locales/sl-SI/global";
import error403 from "@/locales/sl-SI/errors/403";
import error404 from "@/locales/sl-SI/errors/404";
import error500 from "@/locales/sl-SI/errors/500";
import error503 from "@/locales/sl-SI/errors/503";
import error504 from "@/locales/sl-SI/errors/504";
import maintenance from "@/locales/sl-SI/auth/maintenance";
import toast from "@/locales/sl-SI/toast/toast";
import login from "@/locales/sl-SI/auth/login";
import onboarding from "@/locales/sl-SI/auth/onboarding";
import loginPageSteps from "@/locales/sl-SI/loginPageSteps";
import dashboard from "@/locales/sl-SI/dashboard/dashboard";
import account from "@/locales/sl-SI/account/account";
import mailbox from "@/locales/sl-SI/account/mailbox";
import bankstatement from "@/locales/sl-SI/account/bankstatement";
import myApps from "@/locales/sl-SI/my-apps/myApps";
import about from "@/locales/sl-SI/about/about";
import contactService from "@/locales/sl-SI/about/contactService";
import salesPromotions from "@/locales/sl-SI/sales/promotions";
import brochures from "@/locales/sl-SI/sales/brochures";
import shop from "@/locales/sl-SI/shop/data";
import priceList from "@/locales/sl-SI/shop/priceList";
import staff from "@/locales/sl-SI/dashboard/staff";
import promotions from "@/locales/sl-SI/promotions";
import points from "@/locales/sl-SI/points";
import trainings from "@/locales/sl-SI/trainings/trainings";
import vouchers from "@/locales/sl-SI/vouchers/vouchers";
import media from "@/locales/sl-SI/media/index";
import product from "@/locales/sl-SI/product/index";
import message from "@/locales/sl-SI/message/index";
import commitmentLetter from "@/locales/sl-SI/account/commitmentLetter";
import multiplicator from "@/locales/sl-SI/multiplicator";
import consents from "@/locales/sl-SI/consents/consents";
import investment from "@/locales/sl-SI/investment/data";
import kickback from "@/locales/sl-SI/kickback";
//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Slike izdelkov",
    BDriveLinkText: "Povezava do portala SLIK IZDELKOV",
  },
}

export default {
  locale: "sl-SI",
  messages,
};
